import { Smartphone } from "lucide-react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@components/ui/sidebar";
import { useMobileAppBanner } from "./useMobileAppBanner";

export const OpenInAppButton: React.FC = () => {
  const { isMobile, dismissed, appUrl } = useMobileAppBanner();

  if (!isMobile || !dismissed) {
    return null;
  }

  return (
    <SidebarGroup>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild tooltip="Open in App">
              <a href={appUrl}>
                <Smartphone className="size-4" />
                <span>Open in App</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
